import styled from 'styled-components';

export const FormContainer = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: 40px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 12px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 102, 255, 0.08);
  position: relative;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-align: left;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 50px rgba(0, 102, 255, 0.15);
  }
  
  &::before {
    content: '';
    position: absolute;
    top: -5px;
    left: 30px;
    right: 30px;
    height: 10px;
    background: #0066ff;
    border-radius: 5px;
    opacity: 0.7;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 30px;
  text-align: left;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: left;
  margin-bottom: 5px;
`;

export const Label = styled.label`
  font-size: 1rem;
  font-weight: 500;
  color: #333;
  position: relative;
  padding-left: 20px;
  text-align: left;
  display: flex;
  align-items: center;
  
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
    height: 8px;
    background-color: #0066ff;
    border-radius: 50%;
    opacity: 0.9;
  }
`;

export const Input = styled.input`
  padding: 12px 16px;
  font-size: 1rem;
  border: 1px solid rgba(0, 102, 255, 0.1);
  border-radius: 6px;
  transition: border-color 0.3s, box-shadow 0.3s;
  background: rgba(255, 255, 255, 0.8);

  &:focus {
    outline: none;
    border-color: #0066ff;
    box-shadow: 0 0 0 3px rgba(0, 102, 255, 0.1);
  }
  
  &:disabled {
    background: rgba(240, 240, 240, 0.8);
    cursor: not-allowed;
  }
`;

export const TextArea = styled.textarea`
  padding: 12px 16px;
  font-size: 1rem;
  border: 1px solid rgba(0, 102, 255, 0.1);
  border-radius: 6px;
  transition: border-color 0.3s, box-shadow 0.3s;
  background: rgba(255, 255, 255, 0.8);
  resize: vertical;
  min-height: 100px;

  &:focus {
    outline: none;
    border-color: #0066ff;
    box-shadow: 0 0 0 3px rgba(0, 102, 255, 0.1);
  }
  
  &:disabled {
    background: rgba(240, 240, 240, 0.8);
    cursor: not-allowed;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  gap: 10px;
  text-align: left;
  margin-top: 5px;
  
  @media (max-width: 576px) {
    flex-direction: column;
  }
`;

export const OptionalFields = styled.div`
  margin-top: 15px;
  border-top: 1px solid rgba(0, 102, 255, 0.1);
  padding-top: 25px;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const OptionalLabel = styled.p`
  font-size: 0.9rem;
  font-weight: 600;
  color: #666;
  margin-bottom: 10px;
  text-align: left;
`;

export const ErrorMessage = styled.div`
  color: #d32f2f;
  background-color: rgba(211, 47, 47, 0.1);
  border-radius: 4px;
  padding: 10px;
  margin-top: 10px;
  font-size: 0.9rem;
  border-left: 3px solid #d32f2f;
  text-align: left;
`;

export const Button = styled.button`
  background: #0066ff;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s, transform 0.2s;
  box-shadow: 0 4px 6px rgba(0, 102, 255, 0.15);
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to right, rgba(255,255,255,0.1), rgba(255,255,255,0.2));
    opacity: 0;
    transition: opacity 0.3s;
  }

  &:hover {
    background: #0052cc;
    transform: translateY(-2px);
    box-shadow: 0 6px 10px rgba(0, 102, 255, 0.2);
    
    &::after {
      opacity: 1;
    }
  }
  
  &:active {
    transform: translateY(1px);
    box-shadow: 0 2px 4px rgba(0, 102, 255, 0.15);
  }
  
  &:disabled {
    background: #7fadff;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

export const SmallText = styled.p`
  font-size: 0.875rem;
  color: #777;
  text-align: center;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  
  &::before {
    content: '✨';
    font-size: 1rem;
    margin-right: 3px;
  }
`; 